import { useContext } from "react";
import { Alert, Box } from "@mui/material";
import { RecordContext } from "../../../components/record/Record";
import { useUser } from "../../../api/useAuth";
import { isDepartmentAllowed } from "./departmentAccess";

type DynamicTasksEditGuardProps = {
	children: React.ReactNode;
};

export const DynamicTasksEditGuard = ({ children }: DynamicTasksEditGuardProps) => {
	const context = useContext(RecordContext);
	const { data: user } = useUser();

	const canEditDepartment = isDepartmentAllowed(user?.role?.id, context?.item?.department);

	if (!canEditDepartment) {
		return (
			<Box sx={{ px: 4, pt: 2 }}>
				<Alert severity="error">Sem permissão para editar tarefas deste departamento.</Alert>
			</Box>
		);
	}

	return <>{children}</>;
};
